(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/rules/assets/javascripts/rules/keno.js') >= 0) return;  svs.modules.push('/components/numbergames/rules/assets/javascripts/rules/keno.js');

'use strict';

var _svs$numbergames;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const KENO = {
  productId: (_svs$numbergames = svs.numbergames) === null || _svs$numbergames === void 0 || (_svs$numbergames = _svs$numbergames.productMapping) === null || _svs$numbergames === void 0 ? void 0 : _svs$numbergames.CONSTANTS.KENO,
  alwaysOpen: true,
  rowPrice: 5,
  rowPriceMultipliers: [1, 2, 4, 6, 8, 10, 20],
  numbersMaxValue: 70,
  numbersMaxLength: 11,
  kungKeno: true,
  maxNumberOfRows: 12,
  levels: {
    min: 1,
    max: 11,
    preset: 11
  },
  defaultPackage: 90,
  rowPriceMulti: [2, 4, 6, 8, 10, 20],
  winConditions: [{
    level: 1,
    numbers: 1,
    kungKeno: false
  }, {
    level: 2,
    numbers: 2,
    kungKeno: false
  }, {
    level: 3,
    numbers: 2,
    kungKeno: false
  }, {
    level: 4,
    numbers: 2,
    kungKeno: false
  }, {
    level: 5,
    numbers: 3,
    kungKeno: false
  }, {
    level: 6,
    numbers: 3,
    kungKeno: false
  }, {
    level: 7,
    numbers: 4,
    kungKeno: false
  }, {
    level: 8,
    numbers: 4,
    kungKeno: false
  }, {
    level: 9,
    numbers: 5,
    kungKeno: false
  }, {
    level: 10,
    numbers: 5,
    kungKeno: false
  }, {
    level: 11,
    numbers: 5,
    kungKeno: false
  },
  {
    level: 1,
    numbers: 1,
    kungKeno: true
  }, {
    level: 2,
    numbers: 1,
    kungKeno: true
  }, {
    level: 3,
    numbers: 1,
    kungKeno: true
  }, {
    level: 4,
    numbers: 1,
    kungKeno: true
  }, {
    level: 5,
    numbers: 1,
    kungKeno: true
  }, {
    level: 6,
    numbers: 1,
    kungKeno: true
  }, {
    level: 7,
    numbers: 1,
    kungKeno: true
  }, {
    level: 8,
    numbers: 1,
    kungKeno: true
  }, {
    level: 9,
    numbers: 1,
    kungKeno: true
  }, {
    level: 10,
    numbers: 1,
    kungKeno: true
  }, {
    level: 11,
    numbers: 1,
    kungKeno: true
  }],
  possibleDrawCounts: [{
    value: '1',
    label: '1'
  }, {
    value: '2',
    label: '2'
  }, {
    value: '3',
    label: '3'
  }, {
    value: '4',
    label: '4'
  }, {
    value: '5',
    label: '5'
  }, {
    value: '6',
    label: '6'
  }, {
    value: '7',
    label: '7'
  }, {
    value: '14',
    label: '14'
  }, {
    value: '21',
    label: '21'
  }, {
    value: '28',
    label: '28'
  }, {
    value: '35',
    label: '35'
  }],
  PACKAGES: {
    60: {
      rows: 6,
      levels: [3, 4, 6, 8, 10, 11],
      hasKungKeno: true
    },
    90: {
      rows: 9,
      levels: [3, 4, 5, 6, 7, 8, 9, 10, 11],
      hasKungKeno: true
    },
    120: {
      rows: 12,
      levels: [1, 2, 3, 4, 5, 6, 7, 8, 8, 9, 10, 11],
      hasKungKeno: true
    },
    250: {
      rows: 25,
      levels: [4, 4, 5, 5, 5, 6, 6, 6, 6, 7, 7, 7, 7, 8, 8, 8, 8, 9, 9, 9, 10, 10, 10, 11, 11],
      hasKungKeno: true
    }
  },
  SYSTEM: {
    levels: {
      min: 2,
      max: 9,
      preset: 0
    },
    LIMITS: {
      NUMBERS: {
        minRowLength: 0,
        maxRowLength: 0,
        combinationMinLength: {
          2: 3,
          3: 4,
          4: 5,
          5: 6,
          6: 7,
          7: 8,
          8: 9,
          9: 10
        },
        combinationMaxLength: {
          2: 10,
          3: 10,
          4: 10,
          5: 10,
          6: 10,
          7: 10,
          8: 10,
          9: 10
        }
      },
      LEVELS: {
        min: 2,
        max: 9
      }
    }
  }
};
const KENO_SELFSERVICE = _objectSpread(_objectSpread({}, KENO), {}, {
  defaultPackage: 60,
  PACKAGES: {
    30: {
      rows: 6,
      levels: [3, 4, 6, 8, 10, 11],
      hasKungKeno: false
    },
    60: {
      rows: 6,
      levels: [3, 4, 6, 8, 10, 11],
      hasKungKeno: true
    },
    120: {
      rows: 12,
      levels: [1, 2, 3, 4, 5, 6, 7, 8, 8, 9, 10, 11],
      hasKungKeno: true
    },
    250: {
      rows: 25,
      levels: [4, 4, 5, 5, 5, 6, 6, 6, 6, 7, 7, 7, 7, 8, 8, 8, 8, 9, 9, 9, 10, 10, 10, 11, 11],
      hasKungKeno: true
    }
  }
});
if (svs.isServer) {
  module.exports = {
    KENO,
    KENO_SELFSERVICE
  };
} else {
  svs.numbergames.rules.KENO = KENO;
  svs.numbergames.rules.KENO_SELFSERVICE = KENO_SELFSERVICE;
}

 })(window);